import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  InputBase,
  FormHelperText
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(2.5),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid',
    borderColor: theme.palette.mode === 'light' ? '#757575' : '#757575',
    fontSize: 16,
    padding: '10px 12px',
    transition: theme.transitions.create([
      'border-color',
      'background-color',
      'box-shadow',
    ]),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

const Email = (props) => {
  // Local state to store the email without validating it on each keystroke.
  const [email, setEmail] = useState(props.value || "");
  const [localError, setLocalError] = useState(false);
  const [localErrorText, setLocalErrorText] = useState("");

  const handleChange = (event) => {
    setEmail(event.target.value); // We only update the state without validating.

    // We call the parent's onChange to update its state.
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const handleBlur = () => {
    if (email.trim() === "") {
      if (props.noRequired) {
        setLocalError(false);
        setLocalErrorText("");
      } else {
        setLocalError(true);
        setLocalErrorText("Enter email address");
      }
    } else {
      // Email format validation when leaving the input.
      if (/^([A-Za-z0-9+_.-]+)@([\da-zA-Z.-]+)\.+([a-zA-Z.]{2,6})$/.test(email)) {
        setLocalError(false);
        setLocalErrorText("");
      } else {
        setLocalError(true);
        setLocalErrorText("Invalid email format");
      }
    }
  };

  return (
    <FormControl variant="standard" fullWidth>
      <InputLabel shrink htmlFor={props.id}>
        {props.label}
      </InputLabel>
      <BootstrapInput
        fullWidth
        className={`TextField-Email ${props.classNameCustom}`}
        size={props.size}
        id={props.id}
        placeholder={props.placeholder}
        onChange={handleChange} // It only updates the state, without validating.
        onBlur={handleBlur} // It validates when the user removes the focus.
        value={email}
        name={props.name}
        disabled={props.disabled}
        required={props.required}
        autoComplete={props.autoComplete}
        onKeyPress={props.onKeyPress}
        error={props.error || localError}
      />
      {(props.errorText || localErrorText) && (
        <FormHelperText >
          {props.errorText || localErrorText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default Email;
